<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div class="weui-cell" slot="ra_position">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.ra_position || "招聘岗位"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.ra_position"
              placeholder="请输入岗位名称"
            />
          </div>
        </div>
        <div class="weui-cell" slot="ra_neednum">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.ra_neednum || "需求人数"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.ra_neednum"
              minvalue="1"
              maxvalue="99999"
            />
          </div>
        </div>
        <date-field slot="ra_time" :label="customLabel.ra_time || '到岗时间'" v-model="form.main.ra_time" />
        <file-field v-model="form.main.ra_attach" slot="ra_attach"/>
      </custom-layout>
      
      <div class="weui-cells__group textarea-cell">
        <div class="weui-cells__title">岗位职责</div>
        <div class="weui-cells">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <textarea
                class="weui-textarea"
                placeholder="请输入岗位职责"
                rows="3"
                v-model="form.main.ra_duty"
                maxlength="300"
              ></textarea>
              <div class="weui-textarea-counter">
                <span>{{form.main.ra_duty?form.main.ra_duty.length:0}}</span>/300
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="weui-cells__group textarea-cell">
        <div class="weui-cells__title">任职要求</div>
        <div class="weui-cells">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <textarea
                class="weui-textarea"
                placeholder="请输入任职要求"
                rows="3"
                v-model="form.main.ra_require"
                maxlength="300"
              ></textarea>
              <div class="weui-textarea-counter">
                <span>{{form.main.ra_require?form.main.ra_require.length:0}}</span>/300
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">提交</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DateField from "@/components/field/DateField.vue";
import FileField from "@/components/field/FileField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    DateField,
    FileField
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/recruitapply",
      codeField: "ra_code",
      statusField: "ra_statuscode",
      caller: "RecruitApply",
      xtype: "oa-recruitapply-formpanel",
      form: {
        main: {
          ra_position: null,
          ra_neednum: 1,
          ra_time: this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
          ra_duty: null,
          ra_require: null
        }
      }
    };
  },
  methods: {
    save() {
      var me = this,
        main = me.form.main;
      if (!main.ra_position) {
        me.$weui.topTips("请填写岗位名称", 2000);
      } else if (!main.ra_neednum) {
        me.$weui.topTips("请填写需求人数", 2000);
      } else if (!main.ra_duty) {
        me.$weui.topTips("请填写岗位职责", 2000);
      } else if (!main.ra_require) {
        me.$weui.topTips("请填写任职要求", 2000);
      } else {
        me.p_save();
      }
    }
  }
};
</script>